import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import Analytika from "../../../analytika";
export class PasswordLoginForm extends React.Component {
  constructor(props) {
    super(props);
    Analytika.fireEvent("Id_Web_PasswordLogin_View");
    this.onPasswordChange = props.onPasswordChange;
    this.onSubmit = props.onSubmit;
  }

  render() {
    const {
      t,
      error,
      submitting,
      signupEndpoint,
      recoveryEndpoint,
    } = this.props;
    return (
      <form
        data-submit-event="Id_Web_PasswordLogin_Submit"
        onSubmit={this.onSubmit}
      >
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        <LanguageSelector />
        <h1>{t("login:password_title")}</h1>
        

        {error && <div className="invalid show">{error}</div>}

        <div className="material-form-field">
          <input
            autoComplete="off"
            type="password"
            id="password"
            name="password"
            onChange={this.onPasswordChange}
          />
          <label className="material-form-field-label" htmlFor="password">
            {t("signup:password")}
          </label>
        </div>
        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="verify-recover-btn"
          disabled={submitting}
        />
        <div className="info center">
          <a href={recoveryEndpoint}>{t("login:forgot_password")}</a>
        </div>
        <div className="row">
          <p className="footer-link col-xs-12">
            {t("login:new_to_careem")}
            <a href={signupEndpoint}>{t("login:create_account")}</a>
          </p>
        </div>

        <ReCaptcha />
      </form>
    );
  }
}

PasswordLoginForm.propTypes = {
  t: Types.func.isRequired,
  onPasswordChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
};
export default withTranslation()(PasswordLoginForm);
